import {ACTIVE_CLASS} from "../lib/constants";

export const filterFunctions = () => {
  const $btns = $('[data-filter]');

  $btns.on('click', function () {
    const $btn = $(this);

    if (!$btn.hasClass(ACTIVE_CLASS)) {
      const groupBtns = $(`[data-filter-group=${$btn.attr('data-filter-group')}]`);

      groupBtns.removeClass(ACTIVE_CLASS);
      $btn.addClass(ACTIVE_CLASS);
    }
  })
}